import { fetchOrderDetails } from 'fk-cp-common-components/actions/orderDetailsAction';
import ApiInterfaceCaller from 'utils/ApiInterfaceCaller';
import ApiCaller from 'actions/ApiCaller';
import BaseAjaxConfig from 'actions/BaseAjaxConfig';
export var getContextActionsEnum;
(function (getContextActionsEnum) {
    getContextActionsEnum["GET_CONTEXT_REQUEST"] = "GET_CONTEXT_REQUEST";
    getContextActionsEnum["GET_CONTEXT_SUCCESS"] = "GET_CONTEXT_SUCCESS";
    getContextActionsEnum["GET_CONTEXT_ERROR"] = "GET_CONTEXT_ERROR";
    getContextActionsEnum["SET_NONORDER_REDIRECT"] = "SET_NONORDER_REDIRECT";
})(getContextActionsEnum || (getContextActionsEnum = {}));
export const fetchThisOrder = (orderId, ignoreWhitelist = true) => {
    return (dispatch, getState) => {
        dispatch({
            type: getContextActionsEnum.GET_CONTEXT_REQUEST
        });
        // find better way to do this
        ApiInterfaceCaller('get', {
            order_id: orderId
        }, () => fetchOrderDetails({
            apiCaller: ApiCaller,
            config: BaseAjaxConfig,
            method: 'get',
            query: {
                order_id: orderId
            }
        }, {
            ignoreWhitelist
        })(dispatch, getState));
    };
};
export const getContextSuccess = () => {
    return (dispatch) => {
        dispatch({
            type: getContextActionsEnum.GET_CONTEXT_SUCCESS
        });
    };
};
export const getContextError = () => {
    return (dispatch) => {
        dispatch({
            type: getContextActionsEnum.GET_CONTEXT_ERROR,
            error: {}
        });
    };
};
export const setNonOrderRedirection = () => {
    return (dispatch) => {
        dispatch({
            type: getContextActionsEnum.SET_NONORDER_REDIRECT
        });
    };
};
